import type { PortalUser } from "@/api/portal";

/**
 * How the portal names a person to a lab admin (docs#239 note 19795 item 46): the
 * full name when IAM holds one, else the email, else the username. The IAM id only
 * as the last resort, when the user is not in the lab's list at all.
 */
export function personLabel(user: PortalUser | undefined, fallbackId: string | null): string {
  if (user === undefined) return fallbackId ?? "—";
  const name = [user.first_name, user.last_name]
    .map((part) => part?.trim() ?? "")
    .filter((part) => part !== "")
    .join(" ");
  return name || user.email || user.username || user.external_id || user.id;
}

/**
 * The role a lab group grants, without the IAM prefix: `GG-SmartReports-test-lab-Reviewer`
 * reads `Reviewer`. A name that is not a lab group is shown as it came, and a missing
 * name falls back to the id.
 */
export function roleLabel(groupName: string | null, groupId: string | null): string {
  if (groupName === null) return groupId ?? "—";
  const match = /^gg-smartreports-.+-([a-z]+)$/i.exec(groupName);
  return match?.[1] ?? groupName;
}

/** The IAM ids are GUIDs, compared without regard to case. */
export function sameId(a: string | null | undefined, b: string | null | undefined): boolean {
  return !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();
}
